<template>
  <swiper :loop="true" :autoplay="{ delay: 4000,disableOnInteraction: false }" :navigation="true" :modules="modules" ref="mySwiper" class="mainSlide swiper-container">
    <template v-if="banner && banner.length">
      <swiper-slide v-for="item in banner" :key="item.bannerIdx" class="bg2">
        <img :src="item.bannerImg" alt="banner" />
      </swiper-slide>
    </template>
    <template v-else>
      <swiper-slide class="bg2">
        <img src="@/assets/img/core/Main_banner_Casino.jpg" />
      </swiper-slide>
      <swiper-slide class="bg2">
        <img src="@/assets/img/core/Main_banner_Slot.jpg" />
      </swiper-slide>
      <swiper-slide class="bg2">
        <img src="@/assets/img/core/Main_banner_Minigame.jpg" />
      </swiper-slide>
    </template>
  </swiper>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue';
import { mapState } from 'vuex'
import { Autoplay, Navigation } from 'swiper/modules';

export default {
  components: {
    Swiper,
    SwiperSlide
  },
  data() {
    return {
    }
  },
  setup() {
    return {
      modules: [Autoplay, Navigation]
    };
  },
  computed: {
    ...mapState([
      'banner'
    ])
  },
  methods: {
    // async fetchDataFromServer() {
    //   try {
    //     // 서버로부터 데이터를 가져옵니다. (예시로 axios를 사용합니다)
    //     const response = await axios.get('/api/items');
    //     this.items = response.data;

    //     // Swiper를 재생성합니다.
    //     this.$refs.mySwiper.swiper.destroy();
    //     this.$nextTick(() => {
    //       this.$refs.mySwiper.swiper.init();
    //     });
    //   } catch (error) {
    //     console.error('Error fetching data:', error);
    //   }
    // }
  }
}
</script>
<style scoped>
.swiper-slide .motion {
  position: absolute;
  top: 0;
  left: 0;
  animation-name: animate3;
  animation-duration: 2s;
  animation-iteration-count: infinite;
  animation-timing-function: ease-in-out;
  z-index: 30;
}

@keyframes animate3 {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.03);
  }

  100% {
    transform: scale(1);
  }
}</style>
